import { ComponentListenerImpl } from "./ComponentListenerImpl";
/**
 * A base class for systems that will listen to one type of component.
 * This system can be enabled or disabled and will then start/stop listening.
 *
 * Note that in order for the system to work it must be registered with the EntityManager
 * and enabled.
 */
var SystemBase = /** @class */ (function () {
    function SystemBase(componentId) {
        this.mandatoryComponents = null;
        this.ignoreEntitiesWithComponents = null;
        this._isEnabled = true;
        this.onAddComponent = this.onAddComponent.bind(this);
        this.onUpdateComponent = this.onUpdateComponent.bind(this);
        this.onRemoveComponent = this.onRemoveComponent.bind(this);
        this._componentListeners = [
            new ComponentListenerImpl(this, componentId, this.onAddComponent, this.onUpdateComponent, this.onRemoveComponent),
        ];
    }
    Object.defineProperty(SystemBase.prototype, "componentListeners", {
        get: function () {
            return this._componentListeners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SystemBase.prototype, "isEnabled", {
        get: function () {
            return this._isEnabled;
        },
        enumerable: false,
        configurable: true
    });
    SystemBase.prototype.onAddComponent = function (_entity, _newComponent) {
        /* intentionally left empty */
    };
    SystemBase.prototype.onUpdateComponent = function (_entity, _oldComponent, _newComponent) {
        /* intentionally left empty */
    };
    SystemBase.prototype.onRemoveComponent = function (_entity, _oldComponent) {
        /* intentionally left empty */
    };
    SystemBase.prototype.enable = function () {
        this._isEnabled = true;
    };
    SystemBase.prototype.disable = function () {
        this._isEnabled = false;
    };
    SystemBase.prototype.register = function (entityManager) {
        entityManager.registerSystem(this);
    };
    SystemBase.prototype.unregister = function (entityManager) {
        entityManager.unregisterSystem(this);
    };
    SystemBase.prototype.onRegister = function () {
        // Default implementation
    };
    SystemBase.prototype.onUnregister = function () {
        // Default implementation
    };
    return SystemBase;
}());
export { SystemBase };
//# sourceMappingURL=SystemBase.js.map